import styled from 'styled-components';

export const StyledImageContainer = styled.div`
    width: 100%;
    height: 100%;
    img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`;
